<template>
    <div class="list-container">
        <entity-filter 
        :title="title"
            v-show="!showAdvancedFilter" 
            :data-list="reminders" 
            :searchable-fields="searchableFields" 
            show-alphabetized-filter="true" 
            :use-group="true" 
            :group-by-options="groupByOptions"
            :actions="actions"
          >
        </entity-filter>
        <generic-table 
            v-show="!showAdvancedFilter" 
            :title-map="titleMap" 
            :table-body="reminders" 
            :end-point="endPoint">
        </generic-table>
    </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import AdvancedFilter from '../AdvancedFilter';
import EntityFilter from '../EntityFilter';
import GenericTable from '../GenericTable';
import store from '../../store.js';
import { bus } from '../../main';
import advancedSearchResults from '../advancedSearchResult';

export default {
  data() {
    return {
      title: {'icon': 'icon-notifications', 'name': "Reminders"},
      titleMap: {
        'label': 'Label',
        'description': 'Description',
        'days_before': 'Days Before',
        'days_after': 'Days After',
        'status': 'Status'
      },
      
      groupByOptions: {
        'label': 'Label',
        'days_before': 'Days Before',
        'days_after': 'Days After',
        'status': 'Status'
      },
      
      endPoint: '/reminders/{{ id }}/details',
      searchableFields: ['label', 'days_before', 'days_after', 'status'],
      label: 'Loading',
      actions: [
        // { 
        //   name: 'Create Reminder', 
        //   url: "/reminders/create",
        //   perm: "add_reminder"
        // }
      ]
    };
  },
  
  watch: {
      // call this method if the route changes
      '$route': 'fetchAllReminders'
  },
  
  computed:{
    ...mapState({
        reminders: state => state.reminders,
        showAdvancedFilter: state => state.showAdvancedFilter,
        loading: state => state.loading
      })
  },
  
  beforeRouteEnter (to, from, next) {
    store.dispatch('fetchAllReminders');
    next();
  },
  
  mounted() {
    this.toggleSidebar();
  },
  
  methods: {
    toggleSidebar(){
      bus.$emit('toggle-sidebar');
    },
  },
    
  components:{
    GenericTable,
    EntityFilter,
    AdvancedFilter,
    advancedSearchResults,
  }
};
</script>
<style lang="scss" scoped>
h1{
  height: 21px;
}
.list-container{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/reminder/ReminderList.vue